import React, {useState} from "react";
import ReactTable from "../../components/ReactTableWrapper";
import connection from "../../connection";
import general from "../../general";
import withStyles from "@material-ui/core/styles/withStyles";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import modelosStyle from "assets/jss/material-dashboard-pro-react/views/modelosStyle";
import Add from "../../../node_modules/@material-ui/icons/Add";
import SweetAlert from "../../components/SweetAlertWrapper";
import {faSearchPlus, faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "../../../node_modules/@material-ui/icons/Check";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

class Modelos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modelos: [],
      searchTable: ""
    };

    this.showNovoModeloModal = this.showNovoModeloModal.bind(this);

    this.reloadModelos = async (done) => {
      let modelos = await connection.get("modelo/listagem");
      modelos.forEach((modelo) => {
        modelo.actions = this.buildActions(modelo);
      });
      this.setState({
        modelos: modelos
      });
      done && done();
    }
  }

  async showNovoModeloModal() {
    const {classes} = this.props;
    let modelo_designacao = null;
    let modelo_codigo = null;
    let modelo_tipo_curso = null;
    let tags = {};
    let tags_refs = {};

    let tipos_curso = await connection.get("curso/listagem_tipos");
    let tags_curso = await connection.get("curso/listagem_tags");

    let Content = () => {
      const [modelo_tipo_curso_state, setModeloTipoCurso] = useState(null);

      return <form autoComplete="off" className={classes.addForm}>
        <CustomInput
          labelText="Código"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            placeholder: "ex: IPE",
            onChange: (e) => {
              modelo_codigo = e.target.value;
            }
          }}
        />
        <CustomInput
          labelText="Designação"
          id="novoModulo-designacao"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "text",
            name: "designacao",
            onChange: (e) => {
              modelo_designacao = e.target.value
            }
          }}
        />
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="tipo_curso" className={classes.selectLabel}>
            Tipo de Curso
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={modelo_tipo_curso_state}
            onChange={(event) => {
              modelo_tipo_curso = event.target.value;
              setModeloTipoCurso(event.target.value);
            }}
            inputProps={{
              name: "tipo_curso",
              id: "tipo_curso"
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>Selecione o tipo de curso</MenuItem>
            {tipos_curso.map((tipo) => {
              return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={tipo.codigo}>{tipo.designacao}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <div style={{margin: "10px 0"}}>
          {tags_curso.map((tag) => {
            return <FormControlLabel
              control={
                <Checkbox
                  tabIndex={-1}
                  onClick={() => {
                    if (tags[tag.id])
                      delete tags[tag.id];
                    else
                      tags[tag.id] = tag.tag;
                    if (tags_refs[tag.id]) {
                      tags_refs[tag.id].disabled = !!tags[tag.id];
                    }
                  }}
                  checkedIcon={<Check className={classes.checkedIcon}/>}
                  icon={<Check className={classes.uncheckedIcon}/>}
                  classes={{
                    checked: classes.checked
                  }}
                  inputRef={(r) => tags_refs[tag.id] = r}
                />
              }
              classes={{
                label: classes.label
              }}
              label={tag.tag}
            />
          })}
        </div>
      </form>
    };

    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Novo Modelo</span>
        </div>)}
        onConfirm={() => {
          connection.post("modelo/novo", {codigo_modelo: modelo_codigo, designacao: modelo_designacao, tags: Object.keys(tags), tipo_curso: modelo_tipo_curso},
            (data) => {
              if (data.success) {
                this.reloadModelos(() => this.setState({modal: null}));
                general.success("Adicionado novo modelo.", "Sucesso");
              } else {
                general.error("Por favor tente novamente.", "Erro!");
              }
            }
          );
        }}
        onCancel={() => this.setState({modal: null})}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Criar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >{<Content/>}</SweetAlert>)
    });
  }

  buildActions(modelo) {
    return (
      <React.Fragment>
        <Button
          justIcon
          round
          simple
          onClick={() => {
            window.App.hist.push("/modelo/" + modelo.id);
          }}
          style={{margin: 0}}
          color="info"
          className="edit"
        >
          <FontAwesomeIcon icon={faSearchPlus}/>
        </Button>
        <Button
          justIcon
          round
          simple
          style={{margin: 0}}
          onClick={() => {
            this.apagarModelo(modelo)
          }}
          color="danger"
          className="edit"
        >
          <FontAwesomeIcon icon={faTrashAlt}/>
        </Button>
      </React.Fragment>
    );
  }

  componentDidMount() {
    this.reloadModelos();
  }

  apagarModelo = (modelo) => {
    this.setState({
      modal: (
        <SweetAlert
          warning
          title="Apagar Modelo"
          onConfirm={async () => {
            await connection.post("modelo/apagar", {id: modelo.id});
            this.hideModal();
            this.reloadModelos();
          }}
          onCancel={() => this.hideModal()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.danger
          }
          cancelBtnCssClass={
            this.props.classes.button
          }
          confirmBtnText="Apagar"
          cancelBtnText="Cancelar"
          showCancel
        >
          Atenção! Ao apagar este modelo ({modelo.designacao}) toda a estrutura respetiva será apagada e será impossível criar mais cursos com o mesmo. Esta ação é irreversível.
        </SweetAlert>
      )
    });

  };

  hideModal = () => {
    this.setState({
      modal: null
    })
  };

  render() {
    const {classes} = this.props;
    let data = general.filterTable(this.state.modelos, this.state.searchTable);
    return (<div className={classes.modelosContainer}>
      {this.state.modal}
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary">
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <h4 style={{flex: 1}}>Modelos de Curso</h4>
                <CustomInput
                  id="tableSearch"
                  formControlProps={{
                    className: classes.searchInput
                  }}
                  inputProps={{
                    type: "text",
                    name: "tableSearch",
                    placeholder: "Pesquisar",
                    onChange: (e) => {
                      this.setState({searchTable: e.target.value})
                    }
                  }}
                />
                <Button className={classes.addModeloButton + " " + classes.button + " " + classes.primary} onClick={this.showNovoModeloModal}>
                  <Add/> Novo Modelo
                </Button>
              </div>
            </CardHeader>
            <ReactTable
              data={data}
              minRows={1}
              columns={[
                {
                  Header: "Código",
                  accessor: "codigo_modelo",
                  maxWidth: 90
                },
                {
                  Header: "Modelo",
                  id: "modelDesignation",
                  accessor: (d) => d.designacao + (d.tags ? ' (' + d.tags + ')' : ''),
                },
                {
                  Header: "Tipo de curso",
                  accessor: "tipo_curso",
                },
                {
                  Header: "Ativado",
                  accessor: "ativado",
                  Cell: general.Renderers.boolRenderer,
                  maxWidth: 150,
                },
                {
                  Header: "",
                  accessor: "actions",
                  maxWidth: 105,
                  sortable: false,
                  filterable: false
                }
              ]}
              defaultPageSize={10}
              showPaginationBottom={true}
              className="-striped -highlight"
            />
          </Card>
        </GridItem>
      </GridContainer>
    </div>);
  }
}

export default withStyles(modelosStyle)(Modelos);
